export var cibKotlin = ["32 32", "<path d='M1.734 32l15.068-15.333 15.198 15.333zM0 0h16l-16 16.667zM17.865 0l-17.865 18.667v13.333l32-32z'/>"];
